// Analytics utility - Tracking page views without double counting on refresh

/**
 * Initialize analytics session
 * Generates a unique session ID that persists during browser session
 */
export const initializeAnalytics = () => {
  // Check if session ID already exists in sessionStorage (survives refresh)
  let sessionId = sessionStorage.getItem('webAura_sessionId');
  
  if (!sessionId) {
    // Generate new session ID only on first page load
    sessionId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('webAura_sessionId', sessionId);
  }
  
  return sessionId;
};

/**
 * Track a page view
 * @param {string} page - Page name or path
 * @param {string} sessionId - Session ID to prevent double counting
 */
export const trackPageView = async (page = '/', sessionId = null) => {
  try {
    if (!sessionId) {
      sessionId = sessionStorage.getItem('webAura_sessionId');
    }

    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    
    const response = await fetch(`${API_URL}/api/analytics/view`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        page,
        sessionId,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        referrer: document.referrer,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      console.log('📊 Page view tracked:', data);
      return data;
    }
  } catch (err) {
    console.error('❌ Error tracking page view:', err);
  }
};

/**
 * Get analytics data (for admin dashboard)
 * @param {string} token - Admin token for authentication
 */
export const getAnalytics = async (token) => {
  try {
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    
    const response = await fetch(`${API_URL}/api/analytics`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      return await response.json();
    }
    throw new Error('Failed to fetch analytics');
  } catch (err) {
    console.error('❌ Error fetching analytics:', err);
    return null;
  }
};
